'use strict'

// Named constants for events raised across this app's various pub-sub
// mechanisms -- the client-side Vue event buses (event-bus.js here, and
// easytitle24-2.x-site's own commonSite/eventBus.js) and the server's own
// mail event seam (wired up in easytitle24-2.x/server/src/api/mail-events.js).
// Using these instead of raw string literals turns a typo into a
// reference/require-time error instead of a silently-dropped emit with no
// listener.
//
// Lives here, not in any one consuming project, because more than one of
// them needs the same names: easytitle24-2.x-site's own bus (FILES_SENT),
// this project's own Common/event-bus singleton shared across the app and
// site bundles (AUTH_CHANGED), and the server's mail events (the
// ORDER_CONFIRMED_*/PROJECT_UPLOADED_* pairs, previously duplicated in the
// server's own mail-event-names.js).
//
// Written as plain CommonJS (module.exports), not `export const`, so the
// server's plain Node `require()` -- no webpack/babel at runtime -- can
// consume it directly, the same file the client bundles via the 'Common'
// webpack alias: webpack's own ES-module interop resolves
// `import { E24Event } from 'Common/e24-events'` against a module.exports
// object without this file itself needing any transpilation.
//
// PASSWORD_RECOVERY_REQUESTED/USER_INVITED stay defined only in the
// server's own mail-event-names.js, re-exported from janux-persist. That
// package is a server-only dependency, not installed here, and this file
// is also bundled into the browser -- requiring it from here would either
// break the client build or fail to resolve when required by the server,
// depending on which one loaded it.
module.exports = {
	E24Event: {
		FILES_SENT: 'files-sent',
		AUTH_CHANGED: 'auth-changed',
		ORDER_CONFIRMED_ADMIN: 'order.confirmed.admin',
		ORDER_CONFIRMED_CUSTOMER: 'order.confirmed.customer',
		PROJECT_UPLOADED_ADMIN: 'project.uploaded.admin',
		PROJECT_UPLOADED_CUSTOMER: 'project.uploaded.customer'
	}
}



// WEBPACK FOOTER //
// /var/tomcat/.jenkins/workspace/EasyTitle24/easytitle24-2.x-common/e24-events.js